import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import DatePicker from "react-datepicker"; 
import "react-datepicker/dist/react-datepicker.css";
import Datetime from 'react-datetime';
import "react-datetime/css/react-datetime.css";
import { getMonth, getYear,format } from 'date-fns';

import * as types from '../../../actions';
import {crewUnavailabilityAction, updateUnavailability,deleteUnavailability,getUnavailability,saveUnavailability} from '../../../actions/unavailabilityActions';

import {getUserTimeZone} from '../../../utils/userGroupUrlCheck';
import { converDateToLocal } from '../../../utils/commonUtilities';

import Toast from '../../commons/helpers/toast';
import ModalWindow from '../../commons/helpers/modalWindow';

import { ROUTE_AFFILIATE_EVENTS } from '../../../configs/staticConfigs'; // ROUTE_AFFILIATE_SHIFT 
import { LBL_NOTES,LBL_EDIT_UNAVAILABILITY,LBL_DELETE,LBL_EDIT,LBL_SAVE,LBL_ADD_UNAVAILABILITY,LBL_SHIFT_TITLE_SEPARATOR } from '../../../configs/labelConfigs';
import { MSG_INVALID_TIME_SLOT,MSG_ALREADY_UNAVAIL_MARKED,MSG_UNAVAILABILITY_UPDATED_SUCCESS,MSG_UNAVAILABILITY_DELETED_SUCCESS,MSG_REQUIRED, MSG_UNAVAILABILITY_ADDED_SUCCESS } from '../../../configs/msgConfigs';

const localizer = momentLocalizer(moment)

class UnavailabilityTab extends Component {

   constructor(props){
      super(props)

      this.state = {
         toastMessagePop:'',
         toastFlagPop:false,
         toastSuccessPop:true,       
         curMonth:'',
         curYear:'',
         startTime:'00:00',
         endTime:'23:59',
         startDate:'',
         endDate:'',
         isEdit:false,
         unavailabilityId:'',
         notes:'',
         formErrors:{
            startTime: '',
            endTime: '',
            startDate:MSG_REQUIRED,
            endDate:MSG_REQUIRED,
            notes:MSG_REQUIRED
         }
      } 

      this.unavailabilityModal = React.createRef(); 
      
   }

   onCloseToastPop = () =>{ // USED FOR POPUP clientContactAdd
        this.setState({toastFlagPop:false,toastMessagePop:'',toastSuccessPop:false});
    } 

    setToasterStatePop = (isEnabled,message,isSucces,isAutoHide=true) => {
        this.setState({toastFlagPop:isEnabled,toastMessagePop:message,toastSuccessPop:isSucces});
        if(isAutoHide){
            setTimeout(()=> {
                this.onCloseToastPop();
            }, 3000);
        }    
    }     
 
   goToBack = (toolbar) => {
      toolbar.date.setMonth(toolbar.date.getMonth() - 1);
      let month= format(toolbar.date,'M');
      toolbar.onNavigate('prev');
      this.props.crewUnavailabilityAction({month:month,year:toolbar.date.getFullYear(),crewId:this.props.crewId});
      this.setState({curMonth:month,curYear:toolbar.date.getFullYear()});
   }
  
   goToNext = (toolbar) => {
      toolbar.date.setMonth(toolbar.date.getMonth() + 1);
      let month= format(toolbar.date,'M');
      toolbar.onNavigate('next');
      this.props.crewUnavailabilityAction({month:month,year:toolbar.date.getFullYear(),crewId:this.props.crewId});
      this.setState({curMonth:month,curYear:toolbar.date.getFullYear()});
   }

   customToolbar = (toolbar) =>{
      return (
        <div className="rbc-toolbar">        
         <span className="rbc-toolbar-label">Unavailability Calendar of {this.props.showNameInHeader} - {toolbar.label}</span>
         <span className="rbc-btn-group">
            <button onClick={()=>this.goToBack(toolbar)}><i className="fa fa-angle-left"></i></button>
            <button onClick={()=>this.goToNext(toolbar)}><i className="fa fa-angle-right"></i></button>
         </span>
        </div>      
      )
   }   

   eventStyleGetter = (event)=>{
      let backgroundColor = event.isShiftScheduled ? '#055556 !important' : '#558080 !important';
   
      let style = {
         backgroundColor: backgroundColor,             
      };
      return {
         className: event.isShiftScheduled ? 'shift-exist' : 'shift-not-exist', 
         style: style
      };
   }

   showUnavailabilityWindow = (e) =>{
    let startDate = format(e.start,'yyyy-MM-dd')
    let endDate = format(e.end,'yyyy-MM-dd')
    let {formErrors} = this.state;
    formErrors["startDate"] = '';
    formErrors["endDate"] = '';
    this.setState({startDate:startDate,endDate:endDate,formErrors:formErrors},()=>{
        this.unavailabilityModal.current.handleOpenModal();
        let unavailabilityModal = document.getElementById('unavailabilityModal');   
        if(unavailabilityModal) {
            unavailabilityModal.style.width='250px'; // '30%'
        } 
    })
      
   }

    closeUnavailabilityWindow = (e) =>{
        let {formErrors} = this.state;
        formErrors["startDate"] = MSG_REQUIRED;
        formErrors["endDate"] = MSG_REQUIRED;
        formErrors["notes"] = MSG_REQUIRED;
        this.setState({startDate:'',startTime:'00:00',
                          endDate:'',endTime:'23:59',
                          notes:'',unavailabilityId:'', isEdit:false,formErrors:formErrors})
        this.unavailabilityModal.current.handleModelCloseOnly();
    }

   onModalFormReset = (e) =>{
      let {formErrors} = this.state;
      formErrors["startDate"] = MSG_REQUIRED;
      formErrors["endDate"] = MSG_REQUIRED;
      formErrors["notes"] = MSG_REQUIRED;
      this.setState({startDate:'',startTime:'00:00',
                        endDate:'',endTime:'23:59',unavailabilityId:'',
                        notes:'',isEdit:false,formErrors:formErrors})
   }

   onStartDateChange = (date) =>{
        let {formErrors} = this.state;
        let startDate = '';
        if(date){
          startDate = format(new Date(date), 'yyyy-MM-dd');
          formErrors.startDate = "";
        }else{
          startDate = '';
          formErrors.startDate = MSG_REQUIRED;
        }
        
        this.setState({startDate,formErrors});    
    }

    onEndDateChange = (date) =>{
        let {formErrors} = this.state;
        let endDate   = '';
        if(date){
          endDate   = format(new Date(date), 'yyyy-MM-dd');
          formErrors.endDate = "";
        }else{
            formErrors.endDate = MSG_REQUIRED;
        }
        this.setState({endDate,formErrors});
    }

    onStartTimeChange = (time) =>{
        let {formErrors} = this.state;    
        if(time._d !== undefined){
            let startTime = format(new Date(time._d), 'HH:mm');
            formErrors.endTime = '';
            this.setState({startTime,formErrors});
        }
             
    }

    onStartTimeBlur = (time) =>{
        let {formErrors} = this.state; 
        let startTime = '';   
        if(time._d !== undefined){
            startTime = format(new Date(time._d), 'HH:mm');           
            formErrors.startTime = '';
            this.setState({startTime,formErrors});
        }else{
              try{
                    var d = new Date(),
                        s = time,
                        parts = s.match(/(\d+)\:(\d+)/),
                        hours = (parseInt(parts[1].trim(), 10)),
                        minutes = parseInt(parts[2].trim(), 10);

                    d.setHours(hours);
                    d.setMinutes(minutes);
                    startTime = format(d, 'HH:mm');
                    formErrors.startTime = '';
                }catch(err) {
                    formErrors.startTime = MSG_REQUIRED;
                      
                }
        }
        this.setState({startTime,formErrors});
             
    }

    onEndTimeChange = (time) =>{
        let {formErrors} = this.state;    
        if(time._d !== undefined){
            let endTime = format(new Date(time._d), 'HH:mm');           
            this.setState({endTime,formErrors});
        }
             
    }

    onEndTimeBlur = (time) =>{
        let {formErrors} = this.state;
        let endTime = '';
        if(time._d !== undefined){
            endTime = format(new Date(time._d), 'HH:mm');           
            formErrors.endTime = '';
            this.setState({endTime,formErrors});
        }else{
              try{
                    var d = new Date(),
                        s = time,
                        parts = s.match(/(\d+)\:(\d+)/),
                        hours = (parseInt(parts[1].trim(), 10)),
                        minutes = parseInt(parts[2].trim(), 10);

                    d.setHours(hours);
                    d.setMinutes(minutes);
                    endTime = format(d, 'HH:mm');
                    formErrors.endTime = '';
                }catch(err) {
                    formErrors.endTime = MSG_REQUIRED;
                      
                }
        }
        this.setState({endTime,formErrors});
             
    }
   saveUnavailability = (e) =>{
    let timeZone =  getUserTimeZone(window.location);
    let timeZoneOffSet = timeZone.utc_offset
    let {formErrors} = this.state;
      if(formErrors.startDate || formErrors.endDate || formErrors.startTime || formErrors.endTime || formErrors.notes){
         return
      }
      let data = {from_date:this.state.startDate+' '+this.state.startTime + ':00'+timeZoneOffSet,
                      to_date:this.state.endDate+'T'+this.state.endTime + ':00'+timeZoneOffSet,
                      crew_profile_id: this.props.crewId, notes: this.state.notes 
                  }
      if(this.state.isEdit){
          data['id'] = this.state.unavailabilityId;
          this.props.updateUnavailability(data);
      }else{
          this.props.saveUnavailability(data);

      }
   }

   deleteUnavailability = () =>{
        this.props.deleteUnavailability({unavailabilityId:this.state.unavailabilityId})
   }

   onHandleChange = (e) =>{
      let {formErrors} = this.state;
      formErrors["notes"] = '';
      if(!e.target.value.trim()){
          formErrors["notes"] = MSG_REQUIRED;
      }
      this.setState({notes:e.target.value,formErrors:formErrors});
   }

   componentDidMount() {              
        let month = getMonth(new Date())+1;
        let year  = getYear(new Date());
        this.props.crewUnavailabilityAction({year:year,month:month,crewId:this.props.crewId});
        this.setState({curMonth:month,curYear:year});
   }  
   
   componentDidUpdate(prevProps){
      const {activity, status} = this.props;
      if(this.props.crewId > 0 && this.props.crewId!== prevProps.crewId){
         let month = getMonth(new Date())+1;
         let year  = getYear(new Date());
         this.props.crewUnavailabilityAction({year:year,month:month,crewId:this.props.crewId});
         this.setState({curMonth:month,curYear:year});
      }
      if(activity && activity !== prevProps.activity) {
          let arrActResp = activity.split('~~');
          if(arrActResp[0]===types.SAVE_UNAVAILABILITY_SUCCESS){ 
                 this.setToasterStatePop(true,MSG_UNAVAILABILITY_ADDED_SUCCESS,true,true);
                 this.closeUnavailabilityWindow('');
                 this.props.crewUnavailabilityAction({year:this.state.curYear,month:this.state.curMonth,crewId:this.props.crewId});
            }
          else if(arrActResp[0]===types.SAVE_UNAVAILABILITY_ERROR){
            if(this.props.errorData.message == 'already_unavail_marked'){
              this.setToasterStatePop(true,MSG_ALREADY_UNAVAIL_MARKED,false,true);
            }
            else if(this.props.errorData.message == 'invalid_time_slot'){
              this.setToasterStatePop(true,MSG_INVALID_TIME_SLOT,false,true);
            }
            else{
                this.setToasterStatePop(true,this.props.errorData.message,false,true);
            }
          }
          else if(arrActResp[0]===types.UPDATE_UNAVAILABILITY_SUCCESS){ 
                 this.setToasterStatePop(true,MSG_UNAVAILABILITY_UPDATED_SUCCESS,true,true);
                 this.closeUnavailabilityWindow('');
                 this.props.crewUnavailabilityAction({year:this.state.curYear,month:this.state.curMonth,crewId:this.props.crewId});
            }
          else if(arrActResp[0]===types.UPDATE_UNAVAILABILITY_ERROR){
              if(this.props.errorData.message == 'already_unavail_marked'){
                this.setToasterStatePop(true,MSG_ALREADY_UNAVAIL_MARKED,false,true);
              }
              else if(this.props.errorData.message == 'invalid_time_slot'){
                this.setToasterStatePop(true,MSG_INVALID_TIME_SLOT,false,true);
              }
              else{
                  this.setToasterStatePop(true,this.props.errorData.message,false,true);
              }
          }
          else if(arrActResp[0]===types.DELETE_UNAVAILABILITY_SUCCESS){ 
                 this.setToasterStatePop(true,MSG_UNAVAILABILITY_DELETED_SUCCESS,true,true);
                 this.closeUnavailabilityWindow('');
                 this.props.crewUnavailabilityAction({year:this.state.curYear,month:this.state.curMonth,crewId:this.props.crewId});
            }
          else if(arrActResp[0]===types.DELETE_UNAVAILABILITY_ERROR){
            
          }
      }
  }

   formatUnavailabilityData(array){
      let timeZone =  getUserTimeZone(this.props.location);
      let unvailability = [];
      if(array.length>0){
          array.map(item => {
              let unavailObj = {}; 
              let title_date = "";
              let shift_details=item?.shift_details ? item.shift_details :{};  
              let shiftEventTitle = (shift_details && shift_details?.event_title) ? ' '+item.shift_details.title+LBL_SHIFT_TITLE_SEPARATOR+item.shift_details.event_title : ''; 
              unavailObj['id'] = item?.crew_profile_id ? Number(item.crew_profile_id) : item?.crew ? item?.crew : 0;
              unavailObj['unavail_id'] = Number(item.id);
              if(converDateToLocal(item.from_date,timeZone.utc_offset,'ddmmyyyy','-') === converDateToLocal(item.to_date,timeZone.utc_offset,'ddmmyyyy','-')){
                  title_date = converDateToLocal(item.from_date,timeZone.utc_offset,'ddmmyyyyhhmm','-')+' - '+converDateToLocal(item.to_date,timeZone.utc_offset,'hhmm','-') 
              }else{
                title_date = converDateToLocal(item.from_date,timeZone.utc_offset,'ddmmyyyyhhmm','-')+'-'+converDateToLocal(item.to_date,timeZone.utc_offset,'ddmmyyyyhhmm','-')
              }
              
              unavailObj['title'] = title_date+shiftEventTitle;    
              unavailObj['start'] = converDateToLocal(item.from_date,timeZone.utc_offset,'yyyymmddThhmmss','-'); 
              unavailObj['end'] = converDateToLocal(item.to_date,timeZone.utc_offset,'yyyymmddThhmmss','-'); 
              unavailObj['isShiftScheduled'] = (item?.shift && parseInt(item.shift)) ? true :  Object.keys(shift_details).length===0?false:true; 
              unavailObj['shiftId'] = (item?.shift && parseInt(item.shift)) ? item.shift : 0;
              unavailObj['eventId'] = shiftEventTitle.length > 1 ? shift_details?.event_id: 0;
              unavailObj['notes'] = item.notes?item.notes:'';
              unvailability.push(unavailObj);
              return unvailability;

              // crew: 2, crew_name: "Alberto Sanchez", from_date: "2025-01-18T08:00:00Z", id: 20, is_repeat: false, 
              // notes: null shift: 57, to_date: "2025-01-18T12:00:00Z", user: 26

          });          
      }
      return unvailability;
   }

   showEvent = (data) => { 
      if(data.eventId) {
        this.props.history.push(ROUTE_AFFILIATE_EVENTS+'/'+data.eventId);
      }
    //   else if(data.shiftId) {
    //     this.props.history.push(ROUTE_AFFILIATE_SHIFT+'/'+data.shiftId);
    //   }
      else if(!data.shiftId){
          let startDate = data["start"].split('T')[0];
          let startTime = data["start"].split('T')[1].split(':')[0]+':'+data["start"].split('T')[1].split(':')[1];
          let endDate = data["end"].split('T')[0];
          let endTime = data["end"].split('T')[1].split(':')[0]+':'+data["end"].split('T')[1].split(':')[1];
          let unavailabilityId = data["unavail_id"];
          let notes = data["notes"];
          let {formErrors} = this.state;
          formErrors["notes"] = '';
          if(!notes.trim()){
            formErrors["notes"] = MSG_REQUIRED;
          }
          this.setState({startDate:startDate,startTime:startTime,
                      endDate:endDate,endTime:endTime,isEdit:true,unavailabilityId:unavailabilityId,notes:notes,formErrors:formErrors},()=>{
                      this.showUnavailabilityWindow({'start':new Date(startDate+' 00:00:00'),
                      'end':new Date(endDate+' 00:00:00')});
          })
      }
   }

   render(){

      const {unavailability} = this.props;        
      const {formErrors} = this.state;
      let timeZone =  getUserTimeZone(this.props.location);
      let unavailabilityList = this.formatUnavailabilityData(unavailability);    
    
      let todayDate = converDateToLocal(new Date(),timeZone.utc_offset,'dateObj','-');    
      let selectedStartDate = this.state.startDate?new Date(this.state.startDate + ' 00:00:00'):'';
      let selectedEndDate = this.state.endDate?new Date(this.state.endDate + ' 00:00:00'):'';
      let selectedStartTime = this.state.startTime? new Date('2022-10-10 '+this.state.startTime+'00'):'';
      let selectedEndTime = this.state.endTime? new Date('2022-10-10 '+this.state.endTime+'00'):'';
      
      return(
        <>  
           <div className="col-md-12">
                  <div className="box margin-top-12">                    
                     <div className="box-content unavailability">
                        <div className="row">
                            <div className="col-md-12"> 
                                <Calendar
                                    localizer={localizer}
                                    views={['month']}
                                    defaultView = "month"
                                    defaultDate = {new Date()}
                                    getNow={() => todayDate}
                                    components={{
                                    toolbar: this.customToolbar,
                                    }}
                                    events={unavailabilityList}
                                    startAccessor="start"
                                    endAccessor="end"
                                    style={{ height: 600 }}
                                    popup={true}
                                    selectable={true}
                                    onSelectEvent={event => this.showEvent(event)}
                                    onSelectSlot={e => this.showUnavailabilityWindow(e)}
                                    eventPropGetter={this.eventStyleGetter}
                                />
                            </div>                           
                        </div>                       
                     </div>
                  </div>
                  <div className="padding-top-50">&nbsp;</div>
                  <div className="padding-top-50">&nbsp;</div>
                  <div className="padding-top-50">&nbsp;</div>
                  <div className="padding-top-50">&nbsp;</div>
                  <div className="padding-top-50">&nbsp;</div>
                  <div className="padding-top-50">&nbsp;</div>
               </div>

              <ModalWindow modalId="unavailabilityModal" ref={this.unavailabilityModal} resetModalForm={this.onModalFormReset} header={this.state.isEdit?LBL_EDIT_UNAVAILABILITY:LBL_ADD_UNAVAILABILITY} type="" noFooterButtons='yes' >
                  <Toast toastDescription={this.state.toastMessagePop} toastFlag={this.state.toastFlagPop} toastSuccess={this.state.toastSuccessPop} closeToast={this.onCloseToastPop} />
                  <div className="row">
                        <div className="col-md-12">
                            <div className="form-group">
                                <label>Start date</label>
                                    <div className="row">
                                        <div className="col-md-3">
                                            <div className="calendar-input">
                                                <DatePicker 
                                                    selectsStart    
                                                    startDate={selectedStartDate}
                                                    selected={selectedStartDate}
                                                    onChange={selected =>this.onStartDateChange(selected)}
                                                    name="startDate"
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    dropdownMode="select"
                                                    dateFormat="dd/MM/yyyy"
                                                    placeholderText="Select"
                                                    //maxDate={new Date()}
                                                    // minDate={new Date()}
                                                    fixedHeight          
                                                    className={formErrors.startDate.length >0 ? "input-error" : ''}
                                                    disabled={true}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-2">
                                            <div className="time-input ">
                                                <Datetime viewMode='time' dateFormat={false} timeFormat={'HH:mm'} inputProps={{ placeholder: 'Select', name:'startTime', className:formErrors.startTime.length >0 ? "input-error" : ''}}  value={this.state.startTime === '' ? selectedStartTime :  this.state.startTime} onChange={selected=>this.onStartTimeChange(selected)}  onBlur={selected=>this.onStartTimeBlur(selected)} />
                                            </div>
                                        </div>
                                    </div>
                            </div>
                        </div>
                  </div>
                  <div className="row">
                        <div className="col-md-12">
                            <div className="form-group">
                                <label>End date</label>
                                <div className="row">
                                    <div className="col-md-3">
                                        <div className="calendar-input">
                                            <DatePicker 
                                                selected={selectedEndDate}
                                                onChange={selected => this.onEndDateChange(selected)}
                                                name="endDate"
                                                showMonthDropdown
                                                showYearDropdown
                                                dropdownMode="select"
                                                dateFormat="dd/MM/yyyy"
                                                placeholderText="Select"
                                                minDate={selectedStartDate} 
                                                fixedHeight       
                                                className={formErrors.endDate.length >0 ? "input-error" : ''}     
                                                // disabled={eventNoEditStatuses.includes(eventData.status)} 
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-2">
                                        <div className="time-input ">
                                            <Datetime viewMode='time' dateFormat={false} timeFormat={'HH:mm'} inputProps={{ placeholder: 'Select', name:'endTime', className:formErrors.endTime.length >0 ? "input-error" : ''}}  value={this.state.endTime === '' ? selectedEndTime :  this.state.endTime} onChange={selected=>this.onEndTimeChange(selected)} onBlur={selected=>this.onEndTimeBlur(selected)}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="form-group">  
                          <label>{LBL_NOTES} </label>
                          <div className={'text-input'}>
                              <input type="text" placeholder="" name="notes" onChange={this.onHandleChange} className={formErrors.notes.length >0 ? "input-error" : ''} value={this.state.notes || ''}/>
                          </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                          <div className="col-md-12">
                            <button type="button" className="btn btn-primary floatRight" id="save" name="save" onClick={this.saveUnavailability}>{LBL_SAVE}</button>
                            {this.state.isEdit && <button type="button" className="btn-danger btn floatRight" id="save" name="save" onClick={this.deleteUnavailability}>{LBL_DELETE}</button>}
                          </div> 
                  </div> 
              </ModalWindow>
           
        </>
        )
    }

}
const mapStateToProps = (state) => {
      return {
         unavailability:state.unavailability.unavailability,     
         unavailabilityPerDate:state.unavailability.unavailabilityPerDate,  
         unavailableCrews:state.unavailability.unavailableCrews,
         status:state.unavailability.status,
         activity:state.unavailability.activity,      
         errorData:state.unavailability.errorData,
         unavailabilityData:state.unavailability.unavailabilityData
      }
};

const mapDispatchToProps = (dispatch) => {
      return bindActionCreators({
        crewUnavailabilityAction:crewUnavailabilityAction,
        saveUnavailability:saveUnavailability,
        updateUnavailability:updateUnavailability,
        deleteUnavailability:deleteUnavailability,
        getUnavailability:getUnavailability,
    },dispatch);
}
export default connect(mapStateToProps,mapDispatchToProps)(withRouter(UnavailabilityTab));